<div class="app-container">
  <page-header [icon]="'far-building'" [title]="'depots'">
    <ng-container class="header-button">
      <btn
        *ngIf="canCreate"
        [routerLink]="['/depot']"
        [classes]="['btn-first', 'float-right']"
        [icon]="'far-plus'"
        [label]="'depots.create'"
        [spinnerClassesString]="'spinner-white'"
        data-cy="go-depot"
        [title]="'depots.create' | translate"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form [filters]="filters" [entity]="'depots'" (onSubmit)="filter()" (onClearClick)="clearFilters()" [isFilterInvisible]="true">
      <form-row-input
        [label]="'depots.name'"
        [(model)]="filters.name"
        (keyup.enter)="filter()"
        [icon]="'far-list'"
        data-cy="depot-name-filter"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [storageKey]="storageKey"
      [loadingNextItems]="loading"
      [loadingItems]="reloading"
      [items]="depots"
      [columns]="listingColumns"
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [endPage]="endPage"
      [(sortProp)]="filters.sortProp"
      [(sortDir)]="filters.sortDir"
      (reloadList)="filter(1)"
      (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
      (callAction)="callAction($event)"
    ></app-base-listing>
  </section>
</div>
